'use client'
import { APIProvider } from '@vis.gl/react-google-maps'

export const GoogleMapProvider = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[]
}) => {
  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY as string} libraries={['marker']}>
      {children}
    </APIProvider>
  )
}
